/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return async function onSubmit({ value, originalValue, args, change }) {
    if (typeof props.onSubmit === 'function') {
      props.onSubmit(args)
    }
  }
}
